import { BASE_CDN_URL } from './app/components/front-page-redesign/constants';

export default function customImageLoader({ src, width, quality }) {
  /**
   * Cloudflare CDN images are optimized according to the width and quality.
   * we need to pass these parameters to the Cloudflare Transform API to get responsive images.
   */
  if (src.startsWith(BASE_CDN_URL) && width !== undefined) {
    const imagePath = src.split('https://www.nerdwallet.com')[1];
    return `https://www.nerdwallet.com/cdn-cgi/image/format=webp,quality=${quality || 80},width=${width}${imagePath}`;
  }

  /**
   * CPlat team implemented an image optimization service inside Wordpress called Tachyon.
   * It is a service that automatically optimize images based on query parameters in the URL.
   * More info: https://github.com/NerdWallet/article-client-next/blob/025ba22ae411f16215d918857b438ba4b0179437/scripts/image-loader.mjs#L16-L19
   */
  if (src.includes('assets/blog/wp-content/uploads')) {
    if (width !== undefined) {
      const tachyonUrl = src.replace(
        'assets/blog/wp-content/uploads',
        'tachyon',
      );
      const imageUrl = `${tachyonUrl}?w=${width}&q=${quality || 75}`;
      return imageUrl;
    }
  }

  if (src.startsWith('http')) {
    if (width !== undefined) {
      const url = new URL(src);
      url.searchParams.set('w', width);
      url.searchParams.set('q', quality || 75);
      return url;
    }
    return src;
  }

  // Use NextJS image optimization API for relative urls.
  return `/front-page-images/_next/image?url=${src}&w=${width}&q=${quality || 75} `;
}
